import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import CitiesList from '../components/CitiesList'

export default function ManageCities() {

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, []);

  return (
    <div className='eczmembers'>
      <div className="memberTitleContainer">
        <h1 className="newMemberTitle">Cities</h1>
        <Link to="/new-city"><button className="memberAddButton">Add New</button></Link>
      </div>
        <CitiesList />
    </div>
  )
}
